import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export function ConfidenceBadge({ confidence, showTooltip = true }) {
  const config = {
    high: {
      label: 'High',
      className: 'confidence-high text-xs px-2 py-0.5 rounded-full font-medium',
      tooltip: 'Clearly stated in the conversation',
    },
    medium: {
      label: 'Med',
      className: 'confidence-medium text-xs px-2 py-0.5 rounded-full font-medium',
      tooltip: 'Implied in the conversation',
    },
    low: {
      label: 'Low',
      className: 'confidence-low text-xs px-2 py-0.5 rounded-full font-medium',
      tooltip: 'Inferred — verify before acting',
    },
  };

  const c = config[confidence] || config.medium;

  if (!showTooltip) return <span className={c.className}>{c.label}</span>;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`${c.className} cursor-help`}>{c.label}</span>
        </TooltipTrigger>
        <TooltipContent className="bg-foreground text-background text-xs">
          <p>{c.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function PriorityBadge({ priority }) {
  const config = {
    high: { label: 'High', color: 'priority-high' },
    medium: { label: 'Med', color: 'priority-medium' },
    low: { label: 'Low', color: 'priority-low' },
  };
  const c = config[priority] || config.medium;
  return <span className={`text-xs font-medium ${c.color}`}>{c.label}</span>;
}

export function StatusBadge({ status }) {
  const config = {
    'not_started': { label: 'Not started', className: 'status-todo text-xs px-2 py-0.5 rounded-full font-medium' },
    'in_progress': { label: 'In progress', className: 'status-in_progress text-xs px-2 py-0.5 rounded-full font-medium' },
    'done': { label: 'Completed', className: 'status-done text-xs px-2 py-0.5 rounded-full font-medium' },
    'processing': { label: 'Processing', className: 'text-xs px-2 py-0.5 rounded-full font-medium bg-amber-100 text-amber-700 border border-amber-200' },
    'draft': { label: 'Draft', className: 'text-xs px-2 py-0.5 rounded-full font-medium bg-secondary text-muted-foreground border border-border' },
    'active': { label: 'Active', className: 'status-in_progress text-xs px-2 py-0.5 rounded-full font-medium' },
    'completed': { label: 'Completed', className: 'status-done text-xs px-2 py-0.5 rounded-full font-medium' },
    'archived': { label: 'Archived', className: 'text-xs px-2 py-0.5 rounded-full font-medium bg-secondary text-muted-foreground border border-border' },
  };
  const c = config[status] || { label: status, className: 'text-xs px-2 py-0.5 rounded-full font-medium bg-secondary text-muted-foreground border border-border' };
  return <span className={c.className}>{c.label}</span>;
}
